import { useMemo } from "react";

interface LoadingSpinnerProps {
  width?: number;
  height?: number;
  blue?: boolean;
}

export default function LoadingSpinner({
  width,
  height,
  blue
}: LoadingSpinnerProps) {
  const color = useMemo(() => (blue ? "#3e8ed0" : "#eec862"), [blue]);
  const secondaryColor = useMemo(() => (blue ? "#ffe08a" : "#ffe08a"), [blue]);

  return (
    <div className="animate-spin rounded-full h-16 w-16 border-4 border-[#ffe08a] border-t-transparent" />
  );
}
